<template>

<div class="content-scrollload">

	<div class="content-scrollload-bar" v-observe-visibility="onVisibilityChange" />

	<slot></slot>

</div>

</template>

<script>

export default {

	methods: {
	
		onVisibilityChange: function(visible) {

			if (visible) this.$emit('scrolled')
		
		}
	
	}

}

</script>

<style scoped>

.content-scrollload {
	background-color: #fff;
	border-radius: 50%;
	width: 40px;
	line-height: 48px;
	margin: 10px 0px;
	height: 40px;
	border: 1px solid #ddd;
	left: 50%;
	margin-left: -20px;
	text-align: center;
	background-image: url(~@/core/assets/load2.gif);
	background-position: 50% 50%;
	background-size: 32px 32px;
	background-repeat: no-repeat;
	z-index: 2;
}

.content-scrollload-bar {
	display: block;
	position: absolute;
	left: 0px;
	width: 40px;
	pointer-events: none;
	height: 480px;
	top: -480px;
}

.is-mobile .content-scrollload-bar {
	height: 240px;
	top: -240px;
}

.content-scrollload-icon {
	font-size: 24px;
	color: #ffc563;
}

</style>
